import { createFileRoute } from "@tanstack/react-router";

import { EpisodesLibrary } from "@/components/admin/library-pages";

export const Route = createFileRoute("/admin/episodes")({
  component: EpisodesLibrary,
  head: () => ({ meta: [{ title: "Episodes" }] }),
  validateSearch: (search: Record<string, unknown>) => {
    const result: { showId?: string; unassigned?: true } = {};
    if (typeof search.showId === "string" && search.showId.length > 0) {
      result.showId = search.showId;
    }
    if (
      search.unassigned === "1" ||
      search.unassigned === "true" ||
      search.unassigned === true
    ) {
      result.unassigned = true;
    }
    return result;
  },
});
